import A from "classnames";
import o, { useState as P, useRef as j, useCallback as y, useEffect as O, useMemo as Q } from "react";
import V, { useMediaQuery as B } from "react-responsive";
import e from "prop-types";
import { sortBy as W, get as Y } from "lodash";
import { I as b } from "./Icon-BuIPTPJn.es.js";
import { I as S } from "./IconButton-CJS1GKeN.es.js";
import { T as C } from "./index-BB-Wk85r.es.js";
import { u as $ } from "./ThemeProvider--i7ESlT5.es.js";
import { useId as G } from "react-id-generator";
import { p as J, a as X } from "./utils-Ci4OZEP4.es.js";
import { N as L } from "./NoClickOutline-CllwvnB9.es.js";
import './AnnouncementContainer.css';const F = "#000", K = "#fff", U = "1.25rem", Z = "#cb0b16", ee = "#ffa343", oe = "768px", ne = "992px", te = "2.625rem", le = "#008eff", re = "#00857a", ae = "Announcement-compere-module__icon___JgbNB", se = "Announcement-compere-module__description___8K7cE", ce = "Announcement-compere-module__label___apchY", ie = "Announcement-compere-module__overflow___vAbpz", ue = "Announcement-compere-module__inline___77V23", de = "Announcement-compere-module__expanded___gTC1-", me = {
  black: F,
  white: K,
  iconSize: U,
  alertIconColor: Z,
  warningIconColor: ee,
  tabletBreakpoint: oe,
  laptopBreakpoint: ne,
  announcementHeight: te,
  infoIconColor: le,
  successIconColor: re,
  "header-block": "Announcement-compere-module__header-block___cCrAB",
  icon: ae,
  "close-icon": "Announcement-compere-module__close-icon___eQGm3",
  description: se,
  label: ce,
  "container-alert": "Announcement-compere-module__container-alert___6Qztw",
  "click-to-expand": "Announcement-compere-module__click-to-expand___kpJyi",
  overflow: ie,
  inline: ue,
  expanded: de,
  "container-warning": "Announcement-compere-module__container-warning___X1RAe",
  "container-info": "Announcement-compere-module__container-info___uvGlk",
  "container-success": "Announcement-compere-module__container-success___JisS8"
}, pe = "#000", _e = "#fff", fe = "1.25rem", he = "#cb0b16", be = "#ffa343", Ce = "768px", xe = "992px", Ee = "2.625rem", ge = "#519de9", ve = "#7fa829", ke = "Announcement-default-module__icon___SjNTN", we = "Announcement-default-module__description___GY2EY", ye = "Announcement-default-module__label___uaHLT", Ae = "Announcement-default-module__overflow___aC6O9", Te = "Announcement-default-module__inline___EcwXj", Re = "Announcement-default-module__expanded___ZeWaE", Ie = {
  black: pe,
  white: _e,
  iconSize: fe,
  alertIconColor: he,
  warningIconColor: be,
  tabletBreakpoint: Ce,
  laptopBreakpoint: xe,
  announcementHeight: Ee,
  infoIconColor: ge,
  successIconColor: ve,
  "header-block": "Announcement-default-module__header-block___6x-vn",
  icon: ke,
  "close-icon": "Announcement-default-module__close-icon___onsoN",
  description: we,
  label: ye,
  "container-alert": "Announcement-default-module__container-alert___0zsqc",
  "click-to-expand": "Announcement-default-module__click-to-expand___eDDMD",
  overflow: Ae,
  inline: Te,
  expanded: Re,
  "container-warning": "Announcement-default-module__container-warning___B4px6",
  "container-info": "Announcement-default-module__container-info___VPyHM",
  "container-success": "Announcement-default-module__container-success___dcf9t"
}, E = ["alert", "warning", "info", "success"], p = {
  closeLabel: "Close",
  expandLabel: "Expand",
  ignoreLabel: "Ignore",
  previousLabel: "Previous announcement",
  summaryText: "You have {count} notifications",
  showAllText: "View here"
}, Ne = {
  children: e.node.isRequired,
  label: e.string,
  mode: e.oneOf(E),
  onExpand: e.func
}, d = {
  compere: me,
  default: Ie
}, z = (t, n) => {
  let a, l, r;
  switch (t) {
    case "alert":
      a = "warning", l = n.alertIconColor, r = n.white;
      break;
    case "success":
      a = "checkmark", l = n.successIconColor, r = n.white;
      break;
    case "warning":
      a = "warning", l = n.warningIconColor, r = n.black;
      break;
    default:
      a = "info", l = n.infoIconColor, r = n.white;
      break;
  }
  return {
    size: "1.25rem",
    className: n.icon,
    name: a,
    color: l,
    alt_color: r
  };
}, g = ({ styles: t, label: n, overflow: a, childText: l, id: r }) => /* @__PURE__ */ o.createElement(
  "div",
  {
    id: r,
    className: A(
      t.description,
      !n && a && t.inline
    )
  },
  /* @__PURE__ */ o.createElement(C.Body2, { responsive: !0 }, l)
);
g.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  styles: e.object.isRequired,
  label: e.string,
  overflow: e.bool.isRequired,
  childText: e.node.isRequired,
  id: e.string
};
g.defaultProps = {
  label: null,
  id: void 0
};
const v = ({ styles: t, iconLabel: n, onClick: a, expanded: l, ariaControls: r }) => /* @__PURE__ */ o.createElement(
  S,
  {
    name: "close",
    color: "currentColor",
    className: t["close-icon"],
    size: "1.25rem",
    label: n,
    onClick: a,
    ariaControls: l ? void 0 : r,
    ariaExpanded: l ? void 0 : !1,
    ariaHasPopup: !l
  }
);
v.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  styles: e.object.isRequired,
  iconLabel: e.string.isRequired,
  onClick: e.func.isRequired,
  ariaControls: e.string,
  expanded: e.bool
};
v.defaultProps = {
  ariaControls: void 0,
  expanded: !1
};
const T = (t) => {
  const [n] = G(1, "announcement-content-");
  return !t.label && t.overflow ? /* @__PURE__ */ o.createElement("div", { className: t.styles["header-block"] }, /* @__PURE__ */ o.createElement(b, { ...t.iconProps }), /* @__PURE__ */ o.createElement(g, { ...t, id: n }), t.carouselControl, t.showCloseButton && /* @__PURE__ */ o.createElement(v, { ...t, ariaControls: n })) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("div", { className: t.styles["header-block"] }, /* @__PURE__ */ o.createElement(b, { ...t.iconProps }), /* @__PURE__ */ o.createElement("div", { className: t.styles.label }, /* @__PURE__ */ o.createElement(C.Body2, { responsive: !0 }, /* @__PURE__ */ o.createElement("strong", null, t.label))), t.carouselControl, t.showCloseButton && /* @__PURE__ */ o.createElement(v, { ...t, ariaControls: n })), t.expanded && /* @__PURE__ */ o.createElement(g, { ...t, id: n }));
};
T.propTypes = {
  label: e.string,
  overflow: e.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  styles: e.object.isRequired,
  carouselControl: e.node,
  showCloseButton: e.bool.isRequired,
  expanded: e.bool.isRequired,
  onClick: e.func.isRequired,
  iconProps: e.shape({
    alt_color: e.string.isRequired,
    className: e.string.isRequired,
    color: e.string.isRequired,
    name: e.string.isRequired,
    size: e.string.isRequired
  }).isRequired
};
T.defaultProps = {
  label: null,
  carouselControl: null
};
class k extends o.Component {
  state = {
    expanded: this.props.initialExpanded || this.props.overflow
  };
  styles = d[this.props.theme] || d.default;
  role = this.props.mode === "alert" ? "alert" : void 0;
  render() {
    const n = z(this.props.mode, this.styles), a = /* @__PURE__ */ o.createElement("div", { className: this.styles.label }, /* @__PURE__ */ o.createElement(C.Body2, { responsive: !0 }, /* @__PURE__ */ o.createElement("strong", null, this.props.label)));
    let l = this.props.onClose, r = this.props.alternateText.closeLabel || p.closeLabel;
    return !this.state.expanded && this.props.tabletOrSmaller && (l = () => {
      this.props.onExpand(), this.setState({ expanded: !0 });
    }, r = this.props.alternateText.expandLabel || p.expandLabel), this.props.tabletOrSmaller || this.props.overflow ? /* @__PURE__ */ o.createElement(
      "div",
      {
        className: A(
          this.styles[`container-${this.props.mode}`],
          this.state.expanded && this.styles.expanded,
          this.props.overflow && this.styles.overflow
        ),
        role: this.role
      },
      /* @__PURE__ */ o.createElement(
        T,
        {
          ...this.props,
          styles: this.styles,
          childText: this.props.children,
          iconProps: n,
          iconLabel: r,
          onClick: l,
          expanded: this.state.expanded
        }
      )
    ) : /* @__PURE__ */ o.createElement(
      "div",
      {
        className: this.styles[`container-${this.props.mode}`],
        role: this.role
      },
      /* @__PURE__ */ o.createElement(b, { ...n }),
      this.props.label && a,
      /* @__PURE__ */ o.createElement(
        g,
        {
          styles: this.styles,
          label: this.props.label,
          overflow: this.props.overflow,
          childText: this.props.children
        }
      ),
      this.props.carouselControl,
      this.props.showCloseButton && /* @__PURE__ */ o.createElement(
        v,
        {
          styles: this.styles,
          iconLabel: r,
          onClick: l
        }
      )
    );
  }
}
k.propTypes = {
  /** The content of the announcement. Should be composed of only text and links  */
  children: e.node.isRequired,
  /** The label of the announcement */
  label: e.string,
  /** Defines the styling, role, and severity of the content */
  mode: e.oneOf(E),
  /** Callback fired for small screen sizes when the user expands the description. Intended for tracking user interaction. */
  onExpand: e.func,
  /** Translations or alternate text for button labels */
  alternateText: e.shape({
    closeLabel: e.string,
    expandLabel: e.string
  }),
  carouselControl: e.node,
  /** Whether the announcement begins expanded for tablet and mobile. Intended for use internally by `AnnouncementContainer`. */
  initialExpanded: e.bool,
  /** Callback fired when user closes the announcement. Should unmount it. */
  onClose: e.func.isRequired,
  /** Prop automatically added using media queries */
  tabletOrSmaller: e.bool.isRequired,
  /** Theme of the announcement */
  theme: e.oneOf(["default", "compere"]).isRequired,
  /** Whether or not to render the close button in the corner of the announcement */
  showCloseButton: e.bool,
  /** When true, Announcement will appear expanded and without fixed height
   * (same as when expanded in mobile or tablet)
   */
  overflow: e.bool
};
k.defaultProps = {
  alternateText: {},
  carouselControl: null,
  onExpand: () => {
  },
  initialExpanded: !1,
  mode: "info",
  showCloseButton: !0,
  label: null,
  overflow: !1
};
const qe = (t) => {
  const n = $();
  return /* @__PURE__ */ o.createElement(V, { maxWidth: d.default.laptopBreakpoint }, (a) => /* @__PURE__ */ o.createElement(
    k,
    {
      ...t,
      theme: n,
      tabletOrSmaller: a
    }
  ));
};
qe.height = J(
  d.default.announcementHeight
);
const Be = "AnnouncementCarouselControl-module__root___8epb3", Le = "AnnouncementCarouselControl-module__character___OvAez", Pe = "AnnouncementCarouselControl-module__icon___9vxIt", h = {
  root: Be,
  character: Le,
  icon: Pe
}, H = ({
  alternateText: t,
  idx: n,
  total: a,
  toNext: l,
  toPrevious: r
}) => /* @__PURE__ */ o.createElement("div", { className: h.root }, /* @__PURE__ */ o.createElement(
  L.Button,
  {
    className: h.icon,
    disabled: n === 0,
    onClick: r,
    "aria-label": t.previousLabel || p.previousLabel
  },
  /* @__PURE__ */ o.createElement(b, { name: "arrow_left", size: "1.25rem", color: "currentColor" })
), /* @__PURE__ */ o.createElement(C.Body2, { responsive: !0 }, /* @__PURE__ */ o.createElement("span", { className: h.character }, n + 1), /* @__PURE__ */ o.createElement("span", { className: h.character }, "/"), /* @__PURE__ */ o.createElement("span", { className: h.character }, a)), /* @__PURE__ */ o.createElement(
  L.Button,
  {
    className: h.icon,
    disabled: n === a - 1,
    onClick: l,
    "aria-label": t.nextLabel || p.previousLabel
  },
  /* @__PURE__ */ o.createElement(b, { name: "arrow_right", size: "1.25rem", color: "currentColor" })
));
H.propTypes = {
  idx: e.number.isRequired,
  total: e.number.isRequired,
  toNext: e.func.isRequired,
  toPrevious: e.func.isRequired,
  alternateText: e.shape({
    nextLabel: e.string,
    previousLabel: e.string
  }).isRequired
};
const R = {
  /** Translations or alternate text for button labels and summary text */
  alternateText: e.shape({
    nextLabel: e.string,
    previousLabel: e.string,
    closeLabel: e.string,
    expandLabel: e.string,
    summaryText: e.string,
    viewAllText: e.string,
    ignoreLabel: e.string,
    showAllText: e.string
  }),
  /** As in [Announcement](/?path=/docs/2-components-announcement--single-announcement) with the additional
   * required `key` prop for each announcement.
   */
  announcements: e.arrayOf(
    e.shape({
      ...Ne,
      key: e.string.isRequired
    })
  ).isRequired,
  /** Callback fired when the user closes an announcement.
   * Should remove that announcement from `announcements`.
   * Called with the announcement's key.
   */
  onClose: e.func.isRequired,
  /** Callback fired for mobile when the user closes the container without viewing the announcements.
   * Should unmount this container. */
  onIgnore: e.func.isRequired,
  /** Callback fired for tablet and larger when the user advances to the next announcement.
   * Called with the key of the announcement that was interacted with, not the one scrolled to.
   */
  onToNext: e.func,
  /** Callback fired for tablet and larger when the user returns to the previous announcement.
   * Called with the key of the announcement that was interacted with, not the one scrolled to
   */
  onToPrevious: e.func,
  /** Callback fired when an announcement becomes visible to user. On tablet and larger,
   * this is immediately for the the first announcement, then anytime thereafter a user
   * scrolls to an announcement. For mobile, this is when the user expands the list of announcements.
   * This does mean multiple `onView` events will be fired if the user scrolls back and forth.
   * Consuming product should determine whether multiple tracking events should be fired in that case.
   */
  onView: e.func,
  /** The branding of the consuming product */
  theme: X
}, I = {
  alternateText: {},
  onToNext: () => {
  },
  onToPrevious: () => {
  },
  onView: () => {
  },
  theme: void 0
}, N = ({
  alternateText: t,
  announcements: n,
  onClose: a,
  onIgnore: l,
  onView: r,
  theme: m,
  ...x
}) => {
  const [s, u] = P(!1), c = d[m] || d.default, _ = j(null), f = y(({ target: i }) => {
    _.current && !_.current.contains(i) && u(!1);
  }, []);
  if (O(() => {
    if (s)
      return document.addEventListener("click", f), () => {
        document.removeEventListener("click", f);
      };
  }, [s, f]), !s) {
    const i = E[Math.min(
      ...n.map(
        (w) => E.indexOf(w.mode || "info")
      )
    )], D = () => {
      n.forEach((w) => {
        r(w.key);
      }), u(!0);
    };
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        className: A(
          c[`container-${i}`],
          c["click-to-expand"]
        )
      },
      /* @__PURE__ */ o.createElement("div", { className: c["header-block"] }, /* @__PURE__ */ o.createElement(b, { ...z(i, c) }), /* @__PURE__ */ o.createElement("div", { className: c.label }, /* @__PURE__ */ o.createElement(C.Body2, { responsive: !0 }, (t.summaryText || p.summaryText).replace("{count}", n.length)), /* @__PURE__ */ o.createElement(C.Body2, null, /* @__PURE__ */ o.createElement(
        "button",
        {
          className: c.description,
          onClick: D,
          type: "button"
        },
        t.showAllText || p.showAllText
      ))), /* @__PURE__ */ o.createElement(
        S,
        {
          name: "close",
          color: "currentColor",
          className: c["close-icon"],
          size: "1.25rem",
          label: t.ignoreLabel || p.ignoreLabel,
          onClick: l
        }
      ))
    );
  }
  return /* @__PURE__ */ o.createElement("div", { ref: _ }, n.map((i) => /* @__PURE__ */ o.createElement(
    k,
    {
      key: i.key,
      ...i,
      alternateText: t,
      onClose: () => a(i.key),
      theme: m,
      initialExpanded: !0,
      tabletOrSmaller: !0,
      ...x
    }
  )));
};
N.propTypes = R;
N.defaultProps = I;
const q = ({
  alternateText: t,
  announcements: n,
  onClose: a,
  onToNext: l,
  onToPrevious: r,
  onView: m,
  ...x
}) => {
  const [s, u] = P(0), c = Y(n, [s, "key"], null);
  O(() => {
    c !== null && m(c);
  }, [m, c]);
  const _ = y(() => {
    s < n.length - 1 && (l(c), u(s + 1));
  }, [s, c, n.length, l]), f = y(() => {
    s > 0 && (r(c), u(s - 1));
  }, [s, c, r]), i = Q(
    () => n.length > 1 && /* @__PURE__ */ o.createElement(
      H,
      {
        alternateText: t,
        total: n.length,
        idx: s,
        toNext: _,
        toPrevious: f
      }
    ),
    [t, n.length, s, _, f]
  );
  return s > n.length - 1 ? (u(n.length - 1), null) : /* @__PURE__ */ o.createElement(
    k,
    {
      ...n[s],
      ...x,
      onClose: () => a(c),
      alternateText: t,
      carouselControl: i,
      initialExpanded: !0,
      key: void 0
    }
  );
};
q.propTypes = R;
q.defaultProps = I;
const M = ({
  announcements: t,
  preserveOrder: n,
  theme: a,
  ...l
}) => {
  const r = $(a), m = B({
    maxWidth: d.default.laptopBreakpoint
  }), x = B({
    maxWidth: d.default.tabletBreakpoint
  });
  if (!t.length) return !1;
  const s = n ? t : W(
    t,
    (u) => E.indexOf(u.mode || "info")
  );
  return x ? /* @__PURE__ */ o.createElement(
    N,
    {
      announcements: s,
      tabletOrSmaller: !0,
      theme: r,
      ...l
    }
  ) : /* @__PURE__ */ o.createElement(
    q,
    {
      announcements: s,
      tabletOrSmaller: m,
      theme: r,
      ...l
    }
  );
};
M.propTypes = {
  ...R,
  /** Whether to preserve the order of announcements.
   * Otherwise, more critical announcements are prioritized.
   */
  preserveOrder: e.bool
};
M.defaultProps = {
  ...I,
  preserveOrder: !1
};
export {
  M as A,
  qe as R
};
